import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/rem.js'
import './utils/common.css'
import common from '@/utils/common.js'
import 'vant/lib/index.css'
import VueI18n from 'vue-i18n'
import eruda from 'eruda/eruda.js'
var that = this;
if(process.env.NODE_ENV == 'test'){
  eruda.init();
}
Vue.prototype.common = common
Vue.use(VueI18n)
console.log(common.getCookie('qz-lang'))
const i18n = new VueI18n({
  locale: common.getCookie('qz-lang'),    // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'zh-CN': require('./utils/lang/zh'),   // 中文语言包
    'en-US': require('./utils/lang/en')    // 英文语言包
  }
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = i18n.t(to.meta.title)
  }
  next()
})
Vue.config.productionTip = false
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
